<template>
    <div class="whitelabel-landing">
        <div class="logo">
            <img :alt="company" src="/images/whitelabel/horizon/landing/landing-logo.png">
        </div>

        <h1>Find &amp; Book Parking</h1>

        <white-label-search/>

        <whitelabel-landing-comforters/>
    </div>
</template>

<script>
    import WhiteLabelSearch from '../../components/search/WhitelabelSearchBar';
    import WhitelabelLandingComforters from './WhitelabelLandingComforters';

    export default {
        name: 'whitelabel-landing',

        components: { WhiteLabelSearch, WhitelabelLandingComforters },

        props: {
            company: {
                type: String,
                default: 'Parking Logo',
            },
        },
    };
</script>

<style lang="less" rel="stylesheet/less" scoped>
    @import (reference) "~assets/less/variables.less";
    @import (reference) "~bootstrap/less/mixins/clearfix.less";
    @import (reference) "~assets/less/components/mixins/helpers.less";
    @import (reference) "~assets/less/components/mixins/helpers.less";

    .whitelabel-landing {
        .clearfix;
        background: url('/images/whitelabel/horizon/landing/landing-background.jpg') no-repeat;
        background-size: cover;
        height: 100vh;
        width: 100vw;
        text-align: center;
        > .logo {
            position: absolute;
            margin: 10px auto;
            top: 62px;
            left: 0;
            right: 0;
            text-align: center;
            display: block;
            width: 100%;
            @media (min-width: @screen-sm-min) {
                text-align: left;
                margin: 0;
                left: 62px;
            }
            > img {
                max-width: 280px;
                max-height: 200px;
            }
        }
        > h1 {
            margin-top: 36vh;
            margin-bottom: 14px;
            color: #fff;
            font-weight: 700;
            max-width: 100vw;
        }
    }
</style>
